"use strict";

exports.__esModule = true;
exports.convertSeoModel = convertSeoModel;

var _safelyParseJsonData = require("../renderer/utils/safely-parse-json-data");

function convertSeoModel(data) {
  return (0, _safelyParseJsonData.safelyParseJsonData)(data);
}